import React from 'react'
import style from './style.module.scss'
import NewsCell from '../NewsCell'
import Scrollable from '../Scrollable'

const News = () => {


    return (
        <div className={style.newsContainer}>
            <NewsCell />
        </div>
    )
}



export default News